import React,{useState} from "react";
import {Link} from "react-router-dom";
import axiosInstance from "../axiosInstance";
import "../Login.css";

export default function ForgotPassword(){
 const [identifier,setIdentifier]=useState("");
 const [busy,setBusy]=useState(false);
 const [message,setMessage]=useState("");

 const submit=async event=>{
  event.preventDefault();
  setBusy(true);
  try{
   const response=await axiosInstance.post(
    "auth/forgot-password/",
    {identifier:identifier.trim()}
   );
   setMessage(response.data.detail);
  }catch{
   setMessage(
    "If the account can receive recovery instructions, they will be sent. Otherwise contact the assurance office."
   );
  }finally{
   setBusy(false);
  }
 };

 return <main className="auth-recovery-page">
  <form className="auth-recovery-card" onSubmit={submit}>
   <span>ACCOUNT RECOVERY</span>
   <h1>Reset your password</h1>
   <p>
    Enter the username or account number issued to you. For security,
    the system will not confirm whether an account exists.
   </p>

   <label>
    Username or account number
    <input
     required
     autoComplete="username"
     value={identifier}
     onChange={event=>setIdentifier(event.target.value)}
     placeholder="Enter your username"
    />
   </label>

   <button disabled={busy}>
    {busy?"Processing...":"Continue"}
   </button>

   {message&&<div className="auth-recovery-message">{message}</div>}

   <Link className="secondary-link" to="/">
    Return to sign in
   </Link>
  </form>
 </main>
}